'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import type { QuickSearchPage } from '../types'
import type { TrackVisitInput } from './useRecentActivity'

/**
 * Automatically tracks navigation to pages in the nav menu.
 *
 * Entity detail pages (sites, chargers, vehicles, users) are tracked
 * separately by their respective page components.
 */
export default function useTrackNavPageVisits(
  pages: QuickSearchPage[],
  trackVisit: (item: TrackVisitInput) => void
) {
  const pathname = usePathname()

  useEffect(() => {
    const matchingPage = pages.find((page) => page.href === pathname)
    if (!matchingPage) return

    trackVisit({
      id: matchingPage.id,
      category: 'page',
      label: matchingPage.label,
      subLabel: matchingPage.subLabel
    })
  }, [pathname, pages, trackVisit])
}
